/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { responsesPartMeta } from '../models/responsesPartMeta';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class ServiceService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * get service health status
   * @returns any status success
   * @throws ApiError
   */
  public getApiServiceorganizationsStatus(): CancelablePromise<{
    data?: {
      running?: boolean;
      broker?: string;
      git?: string;
      env?: string;
      stage?: string;
      time?: string;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/serviceorganizations/status',
      errors: {
        503: `The service is not ready yet`,
      },
    });
  }

  /**
   * simulate a crash to test incident reporting chain
   * @returns void
   * @throws ApiError
   */
  public getApiServiceorganizationsStatusCrash(): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/serviceorganizations/status/crash',
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * get redis connection pool status
   * @returns any redis connection pool status
   * @throws ApiError
   */
  public getApiServiceorganizationsStatusRedis(): CancelablePromise<{
    data?: {
      poolStats: {
        /**
         * Whether Redis pooling is enabled
         */
        isEnabled: boolean;
        /**
         * Number of available pool slots
         */
        spareResourceCapacity?: number | null;
        /**
         * Current pool size
         */
        size?: number | null;
        /**
         * Number of available connections
         */
        available?: number | null;
        /**
         * Number of borrowed connections
         */
        borrowed?: number | null;
        /**
         * Number of pending connection requests
         */
        pending?: number | null;
        /**
         * Maximum pool size
         */
        max?: number | null;
        /**
         * Minimum pool size
         */
        min?: number | null;
      };
      /**
       * Pod information (only in non-dev environments)
       */
      podInfo?: {
        /**
         * Pod hostname
         */
        name: string;
        /**
         * Kubernetes namespace
         */
        namespace: string;
      };
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/serviceorganizations/status/redis',
    });
  }

}
